export default "__VITE_ASSET__tDQxerOe__"